import { jsx as _jsx } from "react/jsx-runtime";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";
export function ToggleButtonGroup(props) {
    return _jsx(MuiToggleButtonGroup, { ...props });
}
//# sourceMappingURL=ToggleButtonGroup.js.map